import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'


const state = {
    server_data: [],
}

const getters = {
    newsFeed: (state) => {
        let data = state.server_data.sort((a, b) => {
            return new Date(b.time) - new Date(a.time);
        });
        return data;
    }
}

const mutations = {
    initialize(state) {
        state.server_data = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)
    },
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getNewsFeeds')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    getNewsFeeds({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/global/newsFeed/${fiifi.workspace_id}`;
                return api.get(url)
                    .then(data => {
                        if (
                            data.data &&
                            data.data.encrypt &&
                            data.data.encrypt.success &&
                            data.data.encrypt.success[0] &&
                            data.data.encrypt.success[0][0]
                        ) {
                            let list = [];
                            let newsList = data.data.encrypt.success[0][0];
                            if (newsList.data_cb_uuids && newsList.data_cb_uuids.status)
                                newsList.data_cb_uuids.feed.map(item => list.push(item));
                            if (newsList.data_rss_company_list && newsList.data_rss_company_list.status)
                                newsList.data_rss_company_list.feed.map(item => list.push(item));
                            if (newsList.data_rss_tags_list && newsList.data_rss_tags_list.status)
                                newsList.data_rss_tags_list.feed.map(item => list.push(item));
                            commit('merge', list)
                            return Promise.resolve(list)
                        }
                    })
                    .catch(err => {
                        console.error(`Error during investment fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}